import React, { memo } from "react";
import cx from "classnames";
import propTypes from "prop-types";
import styles from "./Header.module.scss";
import Icon from "../../Icon";
import { useExpansionPanelCtx } from "../ExpansionPanelCtx";

export const ICON_POSITION = ["left", "right"];

const Header = ({ children, expandIcon, iconPosition, className }) => {
  const { expanded, toggleExpansion } = useExpansionPanelCtx();

  return (
    <div
      className={cx(
        styles.header,
        { [styles.expanded]: expanded, [styles.noIcon]: expandIcon === null },
        styles[iconPosition],
        className
      )}
      onClick={toggleExpansion}
      role="button"
      tabIndex={-1}
    >
      <div className={styles.title}>{children}</div>
      {expandIcon && <div className={styles.icon}>{expandIcon}</div>}
    </div>
  );
};

Header.defaultProps = {
  expandIcon: <Icon icon="chevron-right" size={12} />,
  iconPosition: "right",
  className: undefined
};

Header.propTypes = {
  children: propTypes.node.isRequired,
  /** Provide your own expand icon or null to not show icon. */
  expandIcon: propTypes.node,
  /** Provide your own expand icon */
  iconPosition: propTypes.oneOf(ICON_POSITION),
  /** Class name for overriding. */
  className: propTypes.string
};

export default memo(Header);
